<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Accounts'"
        :buttons="[
          {
            title: 'Add Account',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'accounts'"
        ref="agGrid"
        :data="data"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import upsert from "./upsert";
export default {
  name: "accounts",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    if (this.user.UserType == 2) {
      this.$router.push("./");
      return false;
    }
    this.$appAxiosAdmin
      .get(`Accounts`)
      .then((response) => {
        this.data = response.data;
      })
      .catch((err) => {
        this.$isError(err);
      });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the account named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Accounts/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Account deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>
